import { GetterTree } from 'vuex'
import { IRootState } from '~/store'
import { SubscriptionState } from '~/store/organization/subscriptions/state'

export default {
  subscriptions: ({ subscriptions }) => subscriptions
} as GetterTree<SubscriptionState, IRootState>
